import axios from 'axios'

const state = {
  projects: [],
  active: null,
}

const getters = {
  projects: state => state.projects,
  active: state => state.active,
}

const actions = {
  async createProject({ commit }, data) {
    const response = await axios.post(`${process.env.VUE_APP_NODE_API_HOST}/projects`, data.projectData)

    commit('CREATE_PROJECT', response.data.data)
    commit('SET_PROJECT', response.data.data)

    return response.data.project
  },

  async getProjects({ commit }) {
    const response = await axios.get(process.env.VUE_APP_NODE_API_HOST + '/projects?page=1&limit=100&ascending=0')

    commit('SET_PROJECTS', response.data.data)

    return response.data.data
  },

  async fetchProject({ commit }, id) {
    const response = await axios.get(`${process.env.VUE_APP_NODE_API_HOST}/projects/${id}`)
    return response.data.data
  },

  async updateProject({ commit }, data) {
    const response = await axios.put(`${process.env.VUE_APP_NODE_API_HOST}/projects/${data.id}`, data.projectData)

    return response.data.data
  },

  async fetchDomains({ commit }) {
    const response = await axios.get(process.env.VUE_APP_NODE_API_HOST + '/projects/domains')
    return response.data.data
  }
}

const mutations = {
  SET_PROJECTS(state, projects) {
    state.projects = projects
  },
  SET_PROJECT(state, project) {
    state.active = project
    localStorage.activeProjectId = project ? project.id : undefined
  },
  CREATE_PROJECT(state, project) {
    state.projects.push(project)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
